import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('sap-configuration/sap-sync-menus?page='+page, {params});
    },
    show(id) {
        return Service().get('sap-configuration/sap-sync-menus/show/'+id);
    },    
    create(params) {
        return Service().post('sap-configuration/sap-sync-menus/create', params);
    },
    update(id, params) {
        return Service().post('sap-configuration/sap-sync-menus/update/'+id, params);
    },
    delete(id) {
        return Service().post('sap-configuration/sap-sync-menus/delete/'+id);
    }
}